"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawTextWrap = function (ctx, lines, x, y, height, lineHeight, direction) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    if (height === void 0) { height = ctx.canvas.height; }
    if (direction === void 0) { direction = "down"; }
    if (!Array.isArray(lines))
        lines = [lines];
    if (direction === "up") {
        ctx.textBaseline = "bottom";
        y = height - lineHeight * (lines.length - 1);
    }
    else if (direction === "down") {
        ctx.textBaseline = "top";
        y = 0;
    }
    else if (direction === "center") {
        ctx.textBaseline = "middle";
        y = (height - lines.length * lineHeight) * .5 + (lineHeight * .5);
    }
    for (var i = 0; i < lines.length; i++) {
        ctx.fillText(lines[i], x, y);
        y += lineHeight;
    }
};
exports.buildFontString = function (fontSize, textStyle, fontFamily) {
    if (textStyle === void 0) { textStyle = ""; }
    if (fontFamily === void 0) { fontFamily = "sans-serif"; }
    return textStyle + " " + fontSize + "px " + fontFamily;
};
exports.getLineHeight = function (fontSize) {
    return fontSize * 1.1;
};
exports.wrap = function (ctx, text, options) {
    ctx.font = exports.buildFontString(options.fontSize, options.textStyle, options.fontFamily);
    var result = [];
    var lines = text.split(/\n/g);
    for (var i = 0; i < lines.length; i++) {
        var line = lines[i];
        var newline = "";
        var words = line.split(/\s+/g);
        for (var j = 0; j < words.length; j++) {
            var word = words[j];
            if (ctx.measureText(newline + " " + word).width > options.width) {
                if (newline.length > 0)
                    result.push(newline);
                newline = "";
            }
            newline = (newline + " " + word).trim();
        }
        result.push(newline);
    }
    return result;
};
exports.widestWord = function (ctx, text, options) {
    ctx.font = exports.buildFontString(options.fontSize, options.textStyle, options.fontFamily);
    return text.split(/\s+/g).reduce(function (a, b) { return ctx.measureText(a).width > ctx.measureText(b).width ? a : b; }, "");
};
var fitToWidth = function (ctx, text, options, precision) {
    if (precision === void 0) { precision = 1; }
    if (!options.fontSizeMin)
        options.fontSizeMin = 1;
    if (!options.fontSizeMax)
        options.fontSizeMax = 1000;
    if (options.fontSizeMax - options.fontSizeMin < precision)
        return options.fontSizeMin;
    var pivot = (options.fontSizeMax - options.fontSizeMin) / 2 + options.fontSizeMin;
    ctx.font = exports.buildFontString(pivot, options.textStyle, options.fontFamily);
    if (ctx.measureText(text).width < options.width)
        return fitToWidth(ctx, text, __assign(__assign({}, options), { fontSizeMin: pivot }), precision);
    else
        return fitToWidth(ctx, text, __assign(__assign({}, options), { fontSizeMax: pivot }), precision);
};
var fitToHeight = function (ctx, text, options, precision) {
    if (precision === void 0) { precision = 1; }
    if (!options.fontSizeMin)
        options.fontSizeMin = 1;
    if (!options.fontSizeMax)
        options.fontSizeMax = 1000;
    if (options.fontSizeMax - options.fontSizeMin < precision)
        return { fontSize: options.fontSizeMin, lines: Array.from(exports.wrap(ctx, text, __assign(__assign({}, options), { fontSize: options.fontSizeMin }))) };
    var pivot = (options.fontSizeMax - options.fontSizeMin) / 2 + options.fontSizeMin;
    var lines = Array.from(exports.wrap(ctx, text, __assign(__assign({}, options), { fontSize: pivot })));
    if (exports.getLineHeight(pivot) * lines.length < options.height)
        return fitToHeight(ctx, text, __assign(__assign({}, options), { fontSizeMin: pivot }), precision);
    else
        return fitToHeight(ctx, text, __assign(__assign({}, options), { fontSizeMax: pivot }), precision);
};
exports.fitToBounds = function (ctx, text, options) {
    text = text.trim();
    if (!options.textShrink)
        return {
            fontSize: options.fontSize,
            lines: !options.textWrap ? [text.replace(/\s+/g, " ")] : Array.from(exports.wrap(ctx, text, options))
        };
    if (!options.textWrap)
        return {
            fontSize: Math.min(fitToWidth(ctx, text, options), options.height / 1.1, options.fontSizeMax),
            lines: [text.replace(/\s+/g, " ")]
        };
    return fitToHeight(ctx, text, __assign(__assign({}, options), { fontSizeMin: 10, fontSizeMax: Math.min(options.fontSizeMax, fitToWidth(ctx, exports.widestWord(ctx, text, options), options)) }));
};
exports.getFittedText = function (ctx, text, options) {
    if (text === void 0) { text = ""; }
    if (options.fontSizeMax === undefined)
        options.fontSizeMax = options.fontSize * 1.5;
    if (options.fontSizeMin === undefined)
        options.fontSizeMin = options.fontSize * .75;
    options.textStyle = ((options.bold ? "bold" : "") + " " + (options.italic ? "italic" : "")).trim();
    return exports.fitToBounds(ctx, text, options);
};
exports.drawTextLines = function (ctx, lines, options) {
    ctx.save();
    if (options.textAlign === "center")
        options.x += options.width * .5;
    if (options.textAlign === "right")
        options.x += options.width;
    if (typeof options.alpha === "number")
        ctx.globalAlpha = options.alpha;
    if (options.fillStyle)
        ctx.fillStyle = options.fillStyle;
    if (options.textAlign)
        ctx.textAlign = options.textAlign;
    ctx.translate(options.x, options.y);
    options.textStyle = ((options.bold ? "bold" : "") + " " + (options.italic ? "italic" : "")).trim();
    ctx.font = exports.buildFontString(options.fontSize, options.textStyle, options.fontFamily);
    if (options.textShrink && !options.textWrap) {
        if (options.textJustify === "center")
            options.textWrap = "center";
        else if (options.textJustify === "bottom")
            options.textWrap = "up";
    }
    exports.drawTextWrap(ctx, lines, 0, 0, options.height, exports.getLineHeight(options.fontSize), options.textWrap);
    ctx.restore();
};
exports.drawText = function (ctx, text, options) {
    if (text === void 0) { text = ""; }
    var _a = exports.getFittedText(ctx, text, options), fontSize = _a.fontSize, lines = _a.lines;
    exports.drawTextLines(ctx, lines, __assign(__assign({}, options), { fontSize: fontSize }));
};
exports.getDrawableDimensions = function (drawable) {
    if (drawable instanceof HTMLImageElement)
        return { width: drawable.naturalWidth, height: drawable.naturalHeight };
    return { width: drawable.width, height: drawable.height };
};
exports.scaleRect = function (r, s) {
    var w = r.width * s;
    var h = r.height * s;
    var x = r.x - ((w - r.width) / 2);
    var y = r.y - ((h - r.height) / 2);
    return { x: x, y: y, w: w, h: h };
};
exports.drawImageStretch = function (ctx, img, x, y, width, height, scale) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    if (width === void 0) { width = ctx.canvas.width; }
    if (height === void 0) { height = ctx.canvas.height; }
    if (scale === void 0) { scale = 1; }
    var _a = exports.getDrawableDimensions(img), dw = _a.width, dh = _a.height;
    var sr = exports.scaleRect({ x: x, y: y, width: width, height: height }, scale);
    ctx.drawImage(img, 0, 0, dw, dh, sr.x, sr.y, sr.w, sr.h);
};
exports.drawImageContain = function (ctx, img, x, y, width, height, scale) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    if (width === void 0) { width = ctx.canvas.width; }
    if (height === void 0) { height = ctx.canvas.height; }
    if (scale === void 0) { scale = 1; }
    var _a = exports.getDrawableDimensions(img), dw = _a.width, dh = _a.height;
    var imgScale = Math.min(width / dw, height / dh);
    var wdiff = width - dw * imgScale;
    var hdiff = height - dh * imgScale;
    var ty = hdiff * .5;
    var tx = wdiff * .5;
    var sr = exports.scaleRect({ x: x + tx, y: y + ty, width: width - wdiff, height: height - hdiff, }, scale);
    ctx.drawImage(img, 0, 0, dw, dh, sr.x, sr.y, sr.w, sr.h);
};
exports.drawImageCover = function (ctx, img, x, y, width, height, scale) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    if (width === void 0) { width = ctx.canvas.width; }
    if (height === void 0) { height = ctx.canvas.height; }
    if (scale === void 0) { scale = 1; }
    var _a = exports.getDrawableDimensions(img), dw = _a.width, dh = _a.height;
    var imgScale = Math.min(dw / width, dh / height);
    var rw = dw - (width * imgScale);
    var rh = dh - (height * imgScale);
    var sr = exports.scaleRect({ x: x, y: y, width: width, height: height }, scale);
    ctx.drawImage(img, rw * .5, rh * .5, dw - rw, dh - rh, sr.x, sr.y, sr.w, sr.h);
};
exports.drawImage = function (ctx, img, options) {
    ({ contain: exports.drawImageContain, cover: exports.drawImageCover, stretch: exports.drawImageStretch })[options.fit || "stretch"](ctx, img, options.x, options.y, options.width, options.height, options.scale);
};
exports.canvasPixelFilters = function (pixelFilters) {
    return function (source) {
        var ctx = source.getContext("2d");
        var imageData = ctx.getImageData(0, 0, source.width, source.height);
        var pixels = imageData.data;
        pixelFilters
            .filter(function (fn) { return typeof fn === "function"; })
            .forEach(function (fn) { return fn(pixels); });
        ctx.putImageData(imageData, 0, 0);
    };
};
exports.filterWhiteTransparent = function (margin) {
    if (margin === void 0) { margin = 9; }
    return function (pixels) {
        var length = pixels.length;
        for (var i = 0; i < length; i += 4)
            pixels[i + 3] = +!(pixels[i + 3] === 255 && (pixels[i] + pixels[i + 1] + pixels[i + 2]) >= (765 - margin)) * pixels[i + 3];
    };
};
